import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export const OFFICE_STAGES = { new: "Por revisar", pending_send: "Pendiente de envío", sent: "Enviada" };
export const refreshOfficeCounts = () => window.dispatchEvent(new Event("visit-office-changed"));
export function useOfficeCounts() {
  const [counts, setCounts] = useState({ new: 0, pending_send: 0, sent: 0 });
  const refresh = useCallback(() => api.get("/field/office/counts").then(({ data }) => setCounts(data)).catch(() => {}), []);
  useEffect(() => {
    refresh(); const interval = setInterval(refresh, 45000);
    window.addEventListener("focus", refresh); window.addEventListener("visit-office-changed", refresh);
    return () => { clearInterval(interval); window.removeEventListener("focus", refresh); window.removeEventListener("visit-office-changed", refresh); };
  }, [refresh]);
  return counts;
}

export const visitDate = (value) => value ? value.slice(0, 10).split("-").reverse().join("/") : "Sin fecha";
export const sentDate = (value) => value ? new Intl.DateTimeFormat("es-CL", { timeZone: "America/Santiago", dateStyle: "medium", timeStyle: "short" }).format(new Date(value)) : "—";

export async function downloadPrivate(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data); const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}